import LocalizationStore from '../Stores/LocalizationStore'
import * as Moment from 'moment'
import { User } from './User'
import ReactTable, { CellInfo } from 'react-table'
import * as React from 'react'
import { Link } from 'react-router-dom'
import UsersStore from '../Stores/UsersStore'
import ConfigStore from '../Stores/ConfigStore'

export class UsersTableItem {
    ls = LocalizationStore.getInstance()
    constructor(
        id: string,
        name: string,
        email: string,
        roles: Array<string>,
        activeDateTime: string,
        lastLoginDateTime: string,
        isActive: Boolean,
        lockoutEnabled: boolean,
        lockoutEnd: Date) {

        const self = this

        this.id = id
        this.name = name
        this.email = email
        this.roles = roles.map((r) => (self.ls.t(r['roleName']))).join(', ')
        this.activeDateTime = Moment(activeDateTime).format('DD.MM.YYYY hh:ss')
        this.lastLoginDateTime = Moment(lastLoginDateTime).format('DD.MM.YYYY hh:ss')
        this.isActive = this.ls.t(isActive.toString() + 'IsActive')
        this.lockoutEnabled = this.ls.t(
            lockoutEnabled && lockoutEnd && new Date(lockoutEnd) > new Date()
                ? 'trueIsActive' : 'falseIsActive'
        )
        this.lockoutEnd = lockoutEnd ? Moment(lockoutEnd).format('DD.MM.YYYY hh:ss') : this.ls.t('no data')
    }

    id: string
    name: string
    email: string
    roles: string
    activeDateTime: string
    lastLoginDateTime: string
    isActive: string
    lockoutEnabled: string
    lockoutEnd: string
}

export function createStub(data: Array<User>) {
    return data.map(u => {
        try {
            return new UsersTableItem(
                u.id,
                u.name,
                u.email,
                u.roles,
                u.activeDateTime,
                u.lastLoginDateTime,
                u.isActive,
                u.lockoutEnabled,
                u.lockoutEnd!)
        } catch {
            return undefined
        }
    }
    ).filter(x => x)
}

export function createColumns() {
    const localizationStore = LocalizationStore.getInstance()
    return [
        {
            Header: localizationStore.t!('PID'),
            maxWidth: 350,
            minWidth: 100,
            accessor: 'id',
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="qDetailLink"
                    to={'/user/' + cellInfo.row.id}
                    id={cellInfo.row.userName}
                >
                    {cellInfo.row.id}
                </Link>
            )
        },
        {
            Header: localizationStore.t!('Full name'),
            accessor: 'name',
            maxWidth: 290,
            minWidth: 100,
            filterMethod: (filter: any, row: any) =>
                -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('email'),
            accessor: 'email',
            maxWidth: 250,
            minWidth: 100
        },
        {
            Header: localizationStore.t('roles'),
            accessor: 'roles',
            maxWidth: 200,
            minWidth: 100,
            filterMethod: (filter: any, row: any) =>
                -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('activeDateTime'),
            accessor: 'activeDateTime',
            maxWidth: 200,
            minWidth: 100,
            filterMethod: (filter: any, row: any) =>
                -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('lastLoginDateTime'),
            accessor: 'lastLoginDateTime',
            maxWidth: 200,
            minWidth: 100,
            filterMethod: (filter: any, row: any) =>
                -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('isActive'),
            accessor: 'isActive',
            maxWidth: 90,
            minWidth: 90,
            filterMethod: (filter: any, row: any) =>
                -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('lockoutEnabled'),
            accessor: 'lockoutEnabled',
            maxWidth: 90,
            minWidth: 90,
            filterMethod: (filter: any, row: any) =>
                -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        },
        {
            Header: localizationStore.t('lockoutEnd'),
            accessor: 'lockoutEnd',
            maxWidth: 200,
            minWidth: 90,
            filterMethod: (filter: any, row: any) =>
                -1 !== row[filter.id].toUpperCase().indexOf(filter.value.toUpperCase())
        }

    ]
}

export function getUsersTable() {
    const usersStore = UsersStore.getInstance()
    const configStore = ConfigStore.getInstance()
    const localizationStore = LocalizationStore.getInstance()

    return (
        <ReactTable
            data={createStub(usersStore.getList)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore!.t('No data text')}
            filterable={true}
            previousText={localizationStore!.t('Previous')}
            nextText={localizationStore!.t('Next')}
            pageText={localizationStore!.t('Page')}
            ofText={localizationStore!.t('of')}
        />
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/UsersTableItem.tsx